import { render, staticRenderFns } from "./editorImage.vue?vue&type=template&id=f5ad284e&scoped=true&"
import script from "./editorImage.vue?vue&type=script&lang=js&"
export * from "./editorImage.vue?vue&type=script&lang=js&"
import style0 from "./editorImage.vue?vue&type=style&index=0&id=f5ad284e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ad284e",
  null
  
)

export default component.exports